import { AutogenModelOrderOtherCharge, AutogenRowOrderOtherCharge } from "./autogen/AutogenModelOrderOtherCharge";

export class ModelOrderOtherCharge extends AutogenModelOrderOtherCharge<RowOrderOtherCharge> {
	constructor() {
		super(RowOrderOtherCharge);
	}
}

export class RowOrderOtherCharge extends AutogenRowOrderOtherCharge {
}